import React from "react";
import { useTranslation } from "react-i18next";
import "./BalanceCard.scss";

export interface BalanceCardItem {
  caption: string;
  balance: string;
  description: string;
}

interface BalanceCardProps {
  items: BalanceCardItem[];
}

const BalanceCard: React.FC<BalanceCardProps> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <div className="balance-card">
      <div className="balance-card-items">
        {items.map((item, index) => (
          <div key={index} className="balance-card-item">
            <div className="balance-card-item-name">{item.description}</div>
            <div className="balance-card-item-caption">{t("dostepne_srodki")}</div>
            <h4 className="balance-card-item-amount">
              {item.balance} {t("zl")}
            </h4>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BalanceCard;

